import type { PerformanceTimePeriodName } from '@savvy/constants/generated/gql-enums';

export function performanceFromQuickDate<T extends { timePeriod?: PerformanceTimePeriodName | null }>({
  performanceOverTime,
  quickDate,
}: {
  performanceOverTime: T[];
  quickDate: PerformanceTimePeriodName;
}): T | undefined {
  return (
    performanceOverTime.find((performance) => performance.timePeriod === quickDate) ||
    // Past Year lookback does not return unless >= 1 year of history
    performanceOverTime.find((performance) => performance.timePeriod === 'all_time')
  );
}
